import { createEntityAdapter } from '@ngrx/entity';
import { OrganisationNewsletterEntityState } from '@get/api-interfaces';
import { CustomEntityState } from '@get/store/configs/states';

export type IState = CustomEntityState<OrganisationNewsletterEntityState>;

export const adapter = createEntityAdapter<OrganisationNewsletterEntityState>({
  selectId: o => o.idOrganisationNewsletter
});
export const initialState: IState = adapter.getInitialState({
  isLoaded: false,
  isLoading: false,
  actives: []
});

export const organisationNewsletterFeatureKey = 'organisationNewsletter';
